module.exports = __webpack_public_path__ + "static/media/ic_menuburger.ac1a2ccc.svg";